import React from "react";

export const PageHero = ({ overline, title, subtitle }) => (
  <section className="relative overflow-hidden border-b border-sared bg-white" data-testid="page-hero">
    <div className="absolute inset-0 opacity-[0.07]"
         style={{ backgroundImage: "repeating-linear-gradient(90deg, #FF3B30 0 1px, transparent 1px 46px)" }} />
    <div className="absolute left-0 top-0 h-full w-[3px] bg-sared" />
    <div className="relative mx-auto max-w-[1400px] px-4 md:px-8 py-14 md:py-20">
      <div className="overline mb-4">{overline}</div>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl leading-[0.9] text-black max-w-3xl">{title}</h1>
      {subtitle && <p className="mt-6 max-w-2xl text-sm md:text-base text-zinc-600">{subtitle}</p>}
    </div>
  </section>
);

export default PageHero;
